import { render, staticRenderFns } from "./WTopNav.vue?vue&type=template&id=1af54797&scoped=true&"
import script from "./WTopNav.vue?vue&type=script&lang=js&"
export * from "./WTopNav.vue?vue&type=script&lang=js&"
import style0 from "./WTopNav.vue?vue&type=style&index=0&id=1af54797&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af54797",
  null
  
)

export default component.exports